<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Masa Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Settings/Tables" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Masalar</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(PlacesGUI).length === 0">
      Sisteminizde ekli
      <strong>salon</strong> bulunamamıştır.
      <br />Masa eklemek için lütfen salon tanımlaması yapınız.
    </b-alert>

    <form @submit.prevent="AddTable" v-if="Object.keys(PlacesGUI).length > 0">
      <b-form-group class="formgroup" label="Salon">
        <b-form-select v-model="Table.PlaceID" :options="PlacesGUI"></b-form-select>
      </b-form-group>

      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in TableGUI"
        :key="index"
      >
        <b-form-input type="text" v-model="Table[index]" @keypress.enter.prevent="AddTable"></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Ekle</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Enums: {
        PlaceName: "Salon Adı",
        Name: "Masa Adı",
        Sort: "Sıralama"
      },
      Table: {
        PlaceID: 0,
        Name: "",
        Sort: 0
      }
    };
  },
  computed: {
    ...mapGetters(["GetStoreData"]),
    ...mapState(["ButtonSize"]),
    TableGUI() {
      return Object.filterKey(this.Table, x => ["PlaceID"].indexOf(x) === -1);
    },
    PlacesGUI() {
      let _Places = [];

      if (this.GetStoreData.Places !== undefined)
        for (let i in this.GetStoreData.Places) {
          const _Place = this.GetStoreData.Places[i];

          _Places.push({
            value: _Place.ID,
            text: _Place.Name
          });
        }

      return _Places;
    }
  },
  methods: {
    async AddTable() {
      this.$store.dispatch("AddLoading", "AddTable");

      await Services.Nozich.Send(
        "AddTable",
        {
          Table: this.Table
        },
        Data => {
          this.$store.dispatch("RemoveLoading", "AddTable");

          if (Data.Status === "Success") {
            this.$router.go(-1);
          }
        }
      );
    }
  }
};
</script>
